import capitalizeString from '@functions/utils/capitalizeString'

export function stringToTitleCase(string: string = '') {
  if (!string || typeof string !== 'string') return ''

  const array = string.split(' ')
  const titleCaseArray = array.map(str => capitalizeString(str))

  return titleCaseArray.join(' ')
}

export default stringToTitleCase
